import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import styled from "styled-components";

import Brand from "./Brand";
import Brands from "./Brands.graphql";
import { FluidAccent } from "../../ui-kit";

export const Component = styled(Brand)`
    ${ FluidAccent }
`;

export function getID(entity) {
    return entity.id;
}

export const name = "Brand";

export function useSearch(token: string) {
    const [execute, { called, data, error, loading }] = useLazyQuery(
        gql(Brands),
    );

    useEffect(
        () => {
            if (!token.length) return;

            if (!called) {
                void execute();
            }
        },
        [called, token],
    );

    const [results, setResults] = useState(undefined);

    useEffect(
        () => {
            if (token.length && data) {
                setResults(
                    data.brands.filter(
                        (brand) => brand.name.toLowerCase().includes(token.toLowerCase())
                            || brand.id.toLowerCase().includes(token.toLowerCase())
                            || brand.legacyID?.toLowerCase?.()?.includes?.(token.toLowerCase())
                            || brand.legacyAlias?.toLowerCase?.()?.includes?.(token.toLowerCase())
                    )
                );
            } else {
                setResults([]);
            }
        },
        [data, token],
    );

    return {
        error,
        loading,
        results,
    };
}
